import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'


const familiesService = {
    getFamilies,
    storeFamily,
    updateFamily,
    getFamily,
    deleteFamily
};

export default familiesService

function getFamilies(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`families?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getFamily(id) {
  return HTTP.get(`family/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeFamily(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-family',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateFamily(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-family',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteFamily(id) {
  return HTTP({
    method: 'post',
    url: 'delete-family',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}